<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="OrderProductId"
      ref="list"
      unit="采购订单执行表"
      :is-dialog-query="isDialogQuery"
      :show-summary="true"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="false"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      urlHash="business/purchase/emptorexecution"
      :temp-params="{
        SortName: 'DocNo',
        SortOrder: 'DESC'
      }"
      @closeDialog="closed"
      isShowText
      :showTextArr="showTextArr"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="onPrint">打印</el-button>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template> 
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import Bus from "@/utils/bus";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    //是否弹窗查询
    isDialogQuery: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/pu/puOrderExecution").default,
      showTextArr: [
        {
          type: "time",
          label: "单据时间",
          startKey: "DocDateStart",
          endKey: "DocDateEnd",
        },
        {
          type: "data",
          label: "客户",
          key: "TradeUnitName",
        },
        {
          type: "data",
          label: "存货",
          key: "ProductName",
        },
      ],
      trendShow: true,
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
    };
  },

  activated() {
    if (this.$refs.list.isSetQuery === false) {
      this.getData();
    }
  },
  mounted() {
    // console.log("1");
    // 
    
    if (!this.$permission.canPrice("/business/purchase/emptorexecution")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "TaxPrice");
      if (findIndex >= 0) list.tableList.splice(findIndex, 1);
      const findIndex0 = list.tableList.findIndex(item => item.tableName == "TaxAmount");
      if (findIndex0 >= 0) list.tableList.splice(findIndex0, 1);
      const findIndex2 = list.tableList.findIndex(item => item.tableName == "PuAmount");
      if (findIndex2 >= 0) list.tableList.splice(findIndex2, 1);
      const findIndex3 = list.tableList.findIndex(item => item.tableName == "UnPuAmount");
      if (findIndex3 >= 0) list.tableList.splice(findIndex3, 1);
      const findIndex4 = list.tableList.findIndex(item => item.tableName == "SettlementAmount");
      if (findIndex4 >= 0) list.tableList.splice(findIndex4, 1);
      const findIndex5 = list.tableList.findIndex(item => item.tableName == "UnWriteoffAmount");
      if (findIndex5 >= 0) list.tableList.splice(findIndex5, 1);
      const findIndex6 = list.tableList.findIndex(item => item.tableName == "InvoiceAmount");
      if (findIndex6 >= 0) list.tableList.splice(findIndex6, 1);
      const findIndex7 = list.tableList.findIndex(item => item.tableName == "UnInvoiceAmount");
      if (findIndex7 >= 0) list.tableList.splice(findIndex7, 1);
      const findIndex8 = list.tableList.findIndex(item => item.tableName == "UnSettlementAmount");
      if (findIndex8 >= 0) list.tableList.splice(findIndex8, 1);
    }
    
    Bus.$on("closeTag", (route) => {
      console.log("route.fullPath 采购订单执行表", route.fullPath);
      console.log("this.$route.fullPath 采购订单执行表", this.$route.fullPath);

      if (route.fullPath === "/business/purchase/emptorexecution") {
        this.$refs.list.data = [];
        this.$refs.list.isSetQuery = false;
      }
    });
  },

  methods: {
    closed(isSetQuery) {
      if (!isSetQuery) {
        this.closeSelectedTag(this.$route);
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "index") {
          // to reload home page
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    onPrint() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      var data = {
        Params: params,
        TableNames: list.tableList,
        ParamsData: list.paramsData,
      };
      sessionStorage.setItem("emptorexecution_print", JSON.stringify(data));

      var origin = location.origin;
      window.open(origin + "/#/business/purchase/emptorexecution/print");
    },
    // getDateFunc(){
    //   return new Promise(resolve=>{
    //       this.api.list({'Code':'ProcessStage'}).then(res=>{
    //         resolve({Data:res.Data,Count:res.Count,Code:res.Code})
    //       })
    //   })
    // },
    //
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.executionExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    getFormData() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.fromData.map((item) => {
            item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
          });
        }
      });
    },
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);
            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );
              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },

    //
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);
            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },

    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>